import React from 'react'
import { Card } from "@blueprintjs/core";
import Nav from './Nav'

class CodePanel extends React.Component {
    openMancer = () => {
        window.open('https://mancer.app')
    }
    openCreatures = () => {
        window.open('https://creature-share.com')
    }
    openSpray = () => {
        window.open('https://github.com/jooshkins/SprayBottle')
    }
    openGame = () => {
        window.open('https://github.com/jooshkins/Divided')
    }

    render() {
        return (
            <div>
                <Nav tabId="Code" />
                <div className="w3-row-padding navbar-padding code" style={{paddingBottom: '1em', paddingTop: '64px'}}>
                    <div className="w3-quarter">
                        <Card interactive={true} onClick={this.openMancer.bind()}>
                            <h5><a href="https://mancer.app">Mancer</a></h5>
                            <p>A magical app for turning your ideas into objects</p>
                            <img alt="Mancer logo" src="icon-mancer.png"/>
                        </Card>
                    </div>
                    <div className="w3-quarter">
                        <Card interactive={true} onClick={this.openCreatures.bind()}>
                            <h5><a href="https://creature-share.com">Creatures</a></h5>
                            <p>An open source scooter share project.</p>
                            <img alt="Creatures logo" src="icon-creatures.png"/>
                        </Card>
                    </div>
                    <div className="w3-quarter">
                        <Card interactive={true} onClick={this.openSpray.bind()}>
                            <h5><a href="https://github.com/jooshkins/SprayBottle">SprayBottle</a></h5>
                            <p>A simple tool for supercharging your scripts</p>
                            <img alt="Spraybottle logo" src="icon-spraybottle.png"/>
                        </Card>
                    </div>
                    <div className="w3-quarter">
                        <Card interactive={true} className="" onClick={this.openGame.bind()}>
                            <h5><a href="https://github.com/jooshkins/Divided">Divided</a></h5>
                            <p>A mobile game about a single-celled organism.</p>
                            <img alt="Divided logo" src="icon-game.png"/>
                        </Card>
                    </div>
                </div>
            </div>
        );
    }
}

export default CodePanel;


// WEBPACK FOOTER //
// ./src/CodePanel.js